import { isEqual } from "lodash";
import { memo } from "react";

export const Memo = <T extends object>(component: React.ComponentType<T>) =>
  memo(component, isEqual);
